import React from "react";
import "./Login.css";
import Header from "../Components/Header";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom"; //Link

export default function ForgetPass() {
  return (
    <>
      <Header mode="dark" />

      <div className="container-fluid">
          <div className="login-wrapper d-flex align-items-center justify-content-center">
            <form className="login-card text-center">
              <h3 className="login-title">Forgot Password</h3>

              <input
                type="email"
                className="form-control login-input"
                placeholder="Register Your Email Address"
              />



              <button className="btn login-btn w-100">
                 <Link to="/login">Register</Link>
                </button>

              <p className="register-text">Dont have an account?</p>

            <Link to="/register">
              <p className="register-link">Register Now</p>
            </Link>
            
            </form>
          </div>
        </div>
      <Feature />
      <Footer />
    </>
  );
}


